
define('jst!lib/_overlay_arrows',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if (left) { %>\n  <div class="arrow arrow-left">\n    <div class="arrow-inner">\n      <div class="icon-32 icon-32-arrow-left"></div>\n    </div>\n  </div>\n<% } %>\n\n<% if (right) { %>\n  <div class="arrow arrow-right">\n    <div class="arrow-inner">\n      <div class="icon-32 icon-32-arrow-right"></div>\n    </div>\n  </div>\n<% } %>');
 });

